// extracted by mini-css-extract-plugin
module.exports = {"container":"Empty_container__2pFgn","noClient":"Empty_noClient__23ezh"};